import React from 'react'
import PropTypes from 'prop-types'
import { Box, Text } from 'pcln-design-system'
import Modal from '../collections-promo/Modal'
import { Content } from '@pcln/ace-content-react'
import { HotelsTypeAheadForm } from '../../../NEW_SEARCH_SearchForms'
import { formatHotelsURL } from '../../../search-forms/utils/hotels-url-formatters'
import HotelsSearchContainer from '../../../../containers/hotels/HotelsSearchContainer'
import { validatePromoDeals } from '../../../../utils/validateHotels'
import { fireSearchClick } from '../../../../actions/GoogleAnalyticsClickActions'
import { ANALYTICS_CATEGORY, HotelSearchFormModalTypes } from '../../../../constants/Constants'
import CONTENT from '../../../../constants/Content'

const HOME_CONTENT = CONTENT.home

const handleVIPGASearchClick = data => {
  fireSearchClick(
    HOME_CONTENT.forms.hotels.ga.searchClickVIP,
    data,
    ANALYTICS_CATEGORY,
    'Feature Box Modal'
  )

  // This version of home-components search form results 'Invalid' string; MVP version of the form will update the GA code pattern
  if (data !== 'Invalid') {
    fireSearchClick(
      HOME_CONTENT.forms.hotels.ga.searchClickVIP,
      HOME_CONTENT.forms.hotels.ga.searchValidSubmissionLabel
    )
  }
}

const handleVIPSubmit = values => {
  const url = formatHotelsURL({
    ...values,
    dealType: 'VIP'
  })
  handleVIPGASearchClick(values)
  window.open(url)
}

const VIPModal = ({ show, onClose }) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      isUsingInnerRef
    >
      <Box px={4} pt={3} pb={4}>
        <Box mb={3}>
          <Text color='text' fontSize={[4, null, null, 5]} fontWeight='bold' style={{ lineHeight: 1.25 }}>
            <Content name={['A88F8AAFAA', 'value']} fallback={'Search VIP Deals'} />
          </Text>
          <Text color='text' fontSize={[3, null, null, 4]} style={{ lineHeight: 1.25 }}>
            <Content name={['D9BCAA89AA', 'value']} fallback={'Save more as a Priceline VIP'} />
          </Text>
        </Box>
        <HotelsSearchContainer
          onSubmit={handleVIPSubmit}
          validate={validatePromoDeals}
          render={props => (
            <HotelsTypeAheadForm
              {...props}
              typeAhead={{
                endpoint: 'hotels',
                keys: ['location']
              }}
              modalType={HotelSearchFormModalTypes.VIP}
            />
          )}
        />
      </Box>
    </Modal>
  )
}

VIPModal.defaultProps = {
  onClose: () => {},
  show: false
}

VIPModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
}

export default VIPModal
